import { INTEGRATIONS } from "@/consts/integrations";
import { i18n } from "@/boot/i18n";
import * as types from "../mutationTypes";

export default {
  getAllWhatsappIntegrations({ commit }, integrations) {
    if (!integrations) {
      return null;
    }
    //Get all whatsapp integrations
    let whatsappIntegrations = integrations.filter((integration) => integration.id === INTEGRATIONS.WHATSAPP);
    if (!whatsappIntegrations || whatsappIntegrations.length === 0) {
      //Whatsapp not configured
      return i18n.t("distribution.messages.whatsapp_not_configured");
    }

    //Get all enabled
    whatsappIntegrations = whatsappIntegrations.filter((integration) => integration.enabled);

    if (whatsappIntegrations.length === 0) {
      //Whatsapp configured but not enabled
      return i18n.t("distribution.messages.whatsapp_not_enabled");
    }

    whatsappIntegrations = whatsappIntegrations.map((integration) => {
      integration.settings = JSON.parse(integration.settings);
      return integration;
    });
    commit(types.SET_WHATSAPP_INTEGRATIONS, { integrations: whatsappIntegrations });
    return null;
  }
};
